import { langRoutePath } from '@bcf-v2/routes/common/app/paths/lang-route-path';
import { tableGamesRouteI18n } from '../i18n/table-games-route-i18n';

export function tableGamesRoutePath(): string {
  return `${langRoutePath()}/${tableGamesRouteI18n()}`;
}
